import styled from "styled-components";
import Colors from "../../constants/Colors";

export const ContainerCallcenter = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-top: 20px;

  @media screen and (max-width: 1200px) {
    margin: 20px;
  }
`;

export const FlexRow = styled.div.attrs({ className: "flex" })`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  overflow: hidden;

  @media screen and (max-width: 900px) {
    flex-wrap: wrap;
    flex-direction: column;
  }
`;

export const FlexCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const DoubleComponents = styled.div`
  display: flex;
  justify-content: space-between;
  margin-right: 30px;

  @media screen and (min-width: 1440px) and (max-width: 1920px) {
    width: 90%;
  }
`;

export const ViewAll = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  font-size: 16px;
  border: none;
  color: #0a5190;
  cursor: pointer;
  width: 93px;
`;

export const ViewScroll = styled.div`
  display: flex;
  width: 100%;
  overflow: scroll;
  padding-bottom: 10px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ButtonMarkConsulta = styled.button<{
  color?: string;
  inverted?: boolean;
  isTablet?: boolean;
}>`
  background-color: ${(props) =>
    props.color ? props.color : props.inverted ? "#E0F0F5" : Colors.lightBlue};
  display: flex;
  color: ${(props) => (props.inverted ? Colors.SPM600 : "white")};
  width: ${(props) => (props.isTablet ? "100%" : "auto")};
  flex-direction: row;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  gap: 12px;
  border: ${(props) =>
    props.inverted ? "0px solid #4D638D" : "0px solid #4D638D"};
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  letter-spacing: 0.5px;
  margin-top: ${(props) => (props.isTablet ? "20px" : "auto")};
  height: ${(props) => (props.isTablet ? "50px" : "50px")};
  margin-right: ${(props) => (props.isTablet ? "0px" : "5px")};;

  &:disabled {
    opacity: 0.5;
  }

  &:hover {
    cursor: ${(props) => (props.disabled ? "text" : "pointer")};
  }

  &:active {
    background-color: ${(props) => (props.disabled ? "" : "#D7DDF4")};
    color: ${(props) => (props.disabled ? "" : Colors.lightBlue)};
    border-color: ${(props) => (props.disabled ? "" : "#D7DDF4")};
  }

  @media screen and (min-width: 900px) and (max-width: 1225px) {
    width: 100%;
  }


`;
